import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Icon, Row, Col, Button, Divider, Input, message, Modal, Select, Table, Spin } from 'antd';
import { getCookie } from './../../hook';
import './style.css';
import _, { values } from 'underscore';
import moment from 'moment';

// actions
import { get_carryforward, get_users, save_carryforward, delete_carryforward, update_carryforward } from './actions/carry.action';

// Child
import NewCarry from './childs/new.carry';

let timer,x;

const confirm = Modal.confirm;
const Option = Select.Option;

class IndvCarryForward extends Component {

    constructor( props ) {
        super( props );

        this.state = {
            visible: false,
            spinLoading: false,
            data: [],
            users_list: [],
        }

        this.handleNewCarryforward = this.handleNewCarryforward.bind( this );
        this.handleDeleteCarry = this.handleDeleteCarry.bind( this );
        this.handleSaveCarry = this.handleSaveCarry.bind( this );
        this.handleCancelCarry = this.handleCancelCarry.bind( this );
        this.handleEditCarryForward = this.handleEditCarryForward.bind( this );
    }


    handleEditCarryForward( id, text, value ){

        let self = this;

        clearTimeout(timer);
        timer = setTimeout(() => {
            self.props.update_carryforward( id, text, value );
        }, 700 );


    }

    handleSaveCarry( data ){
        this.setState({ spinLoading: true })
        this.props.save_carryforward( data );
    }
    
    handleCancelCarry() {
        this.setState({ visible: false });
    }

    componentWillMount() {
        
        this.props.get_carryforward();
        this.props.get_users();

    }

    componentWillReceiveProps( nextProps ) {

        if( nextProps.ind_carryforward.length !== 0 ) {

            if( nextProps.ind_carryforward.STATUS.MESSAGE === "Successfully Listed Carry Forward" ) {
                this.setState({
                    data: nextProps.ind_carryforward.OUTPUT.DATA
                })
            }

            if( nextProps.ind_carryforward.STATUS.MESSAGE === "Get Employee List" ) {
                this.setState({
                    users_list: nextProps.ind_carryforward.OUTPUT.DATA
                })
            }

            if( nextProps.ind_carryforward.STATUS.MESSAGE === "Successfully Saved Carry Forward" ) {
                this.setState({ visible: false, spinLoading: false });
                nextProps.get_carryforward();
            }

            if( nextProps.ind_carryforward.STATUS.MESSAGE === "Successfully Deleted Carry Forward" ) {
                this.setState({ visible: false, spinLoading: false });
                nextProps.get_carryforward();
            }

            if( nextProps.ind_carryforward.STATUS.MESSAGE === "Successfully Updated" ) {
                message.success( "Successfully Updated" );
                this.setState({ visible: false, spinLoading: false });
                nextProps.get_carryforward();
            }

            if( nextProps.ind_carryforward.STATUS.CODE === "400" ) {
                this.setState({ visible: false, spinLoading: false });
                message.error( nextProps.ind_carryforward.STATUS.MESSAGE );
            }

        }

    }

    handleNewCarryforward() {
        this.setState({ visible: true });
    }

    handleDeleteCarry( id ) {

        let self = this;

        confirm({
            title: 'Do you want to delete this?',
            onOk() {
                self.props.delete_carryforward( id );
            },
            onCancel() {
                // Nothing
            },
        });

    }

    render() {

        const columns_list = [
            {
                title : 'Employee Name',
                dataIndex : 'full_name',
                key : 'full_name',
                width: '70%',
            },
            {
                title : 'Carry Forward',
                key : 'carry_forward',
                width: '10%',
                render: data => <Input 
                onChange={ e => this.handleEditCarryForward( data.indv_carry_forward_id, 'carry_forward' , e.target.value ) }
                defaultValue={ data.carry_forward } type="number" />
            },
            {
                title : 'Carry Forward Year',
                key : 'carry_forward_year',
                width: '10%',
                render: data => <Select
                    defaultValue={ data.carry_forward_year }
                    onChange={ value => this.handleEditCarryForward( data.indv_carry_forward_id, 'carry_forward_year', value ) }
                    style={{ width: '100%' }}>
                    <Option key="2014">2014</Option>
                    <Option key="2015">2015</Option>
                    <Option key="2016">2016</Option>
                    <Option key="2017">2017</Option>
                    <Option key="2018">2018</Option>
                    <Option key="2019">2019</Option>
                    <Option key="2020">2020</Option>
                    <Option key="2021">2021</Option>
                    <Option key="2022">2022</Option>
                    <Option key="2023">2023</Option>
                    <Option key="2024">2024</Option>
                    <Option key="2025">2025</Option>
                </Select>
            },
            {
                title : 'Actions',
                key : 'actions',
                width: '10%',
                render: ( data ) => <span>
                    <Button 
                        onClick={ ()=> this.handleDeleteCarry( data.indv_carry_forward_id ) }
                        icon="delete" type="danger"
                        className="table_delete" />
                </span>
            }
        ]

        

        return (

            <div className="carry_wrapper">
                <Spin spinning={ this.state.spinLoading }>
                    
                    <Row gutter={16}>
                        <Col span={12}>
                            <h2>
                                <Icon type="solution" />
                                &nbsp; Carry Forward
                            </h2>
                        </Col>
                        <Col span={12}>

                            <Button
                                onClick={ this.handleNewCarryforward }
                                className="fl_right" type="primary" icon="plus">New</Button>

                        </Col>
                    </Row>

                    <Divider />

                    <Row gutter={16}>
                        <Col span={24}>
                            <Table columns={ columns_list } dataSource={ this.state.data } />
                        </Col>
                    </Row>

                </Spin>

                <NewCarry 
                    usersList={ this.state.users_list }
                    onSubmit={ this.handleSaveCarry }
                    onCancel={ this.handleCancelCarry }
                    onVisible={ this.state.visible }/>

            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        ind_carryforward: state.ind_carryforward
    }
}


export default connect( mapStatetoProps, { 
    get_carryforward, 
    get_users, 
    save_carryforward, 
    delete_carryforward, 
    update_carryforward } ) ( IndvCarryForward );



// WEBPACK FOOTER //
// ./src/pages/individual_carry_forwards/index.js